import { ContentfulImage } from '@ecomm/contentful-components'
import {
  IMG_6AZWds73eDs6cYUcsNTOb4,
  IMG_6CiupNcbwZWioKOCt3PIAA,
  IMG_7rTc0nb3AVq5NG9WLUcG5I
} from '@ecomm/contentful-media'
import RatingBar from './RatingBar'

import React from 'react'

function AppRating() {
  return (
    <div
      className="flex flex-row justify-center md:justify-start"
      data-component="AppRating"
    >
      <div className="hidden pt-1 md:mr-3 md:block">
        <ContentfulImage
          classNameOverride="p-auto m-auto h-16 w-16"
          {...IMG_7rTc0nb3AVq5NG9WLUcG5I}
        />
      </div>
      <div className="flex flex-col">
        <RatingBar
          logo={IMG_6AZWds73eDs6cYUcsNTOb4}
          ratings="300K Ratings (as of 6/24)"
          stars="4.8"
          url="https://apps.apple.com/us/app/simplisafe-home-security-app/id555798051"
        />
        <RatingBar
          logo={IMG_6CiupNcbwZWioKOCt3PIAA}
          ratings="23K Ratings (as of 6/24)"
          stars="4.6"
          url="https://play.google.com/store/apps/details?id=com.simplisafe.mobile&hl=en&gl=US"
        />
      </div>
    </div>
  )
}

export default React.memo(AppRating)
